document.addEventListener("DOMContentLoaded", function () {
  const counterElement = document.querySelector(".bagCounterElement");
  if (!counterElement) return;

  // Function to initialize the counter with spinning digits
  function initializeCounterWithSpinningDigits() {
    const digitCount = 7; // Number of digits
    counterElement.innerHTML = ""; // Clear existing content
    for (let i = 0; i < digitCount; i++) {
      let digitContainer = document.createElement("div");
      digitContainer.className = "number";
      digitContainer.textContent = Math.floor(Math.random() * 10); // Start with random digit
      counterElement.appendChild(digitContainer);
    }

    // Start spinning digits continuously
    counterElement.spinningInterval = startContinuousSpin(counterElement);
  }

  function startContinuousSpin(counterElement) {
    const digitContainers = counterElement.childNodes;
    return setInterval(() => {
      digitContainers.forEach((digitContainer) => {
        digitContainer.textContent = Math.floor(Math.random() * 10); // Random spinning digits
      });
    }, 20); // Adjust the interval to match the visible spin speed
  }

  initializeCounterWithSpinningDigits(); // Initialize the counter with spinning digits on page load

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.animationStarted) {
        const counterElement = entry.target;

        counterElement.animationStarted = true; // Prevent the animation from running multiple times

        const initialCount = parseInt(
          counterElement.getAttribute("data-initial"),
          10
        );
        const dailyIncrement = parseInt(
          counterElement.getAttribute("data-increment"),
          10
        );
        const startDate = new Date(
          counterElement.getAttribute("data-start-date")
        );
        const initialSpinDuration = parseInt(
          counterElement.getAttribute("data-spin-duration"),
          10
        );
        const stopDelay = parseInt(
          counterElement.getAttribute("data-stop-delay"),
          10
        );
        const currentDate = new Date();

        const hoursElapsed = (currentDate - startDate) / 1000 / 3600;
        const hourlyIncrement = dailyIncrement / 24;
        const totalBagsSaved =
          initialCount + Math.floor(hoursElapsed * hourlyIncrement);

        clearInterval(counterElement.spinningInterval); // Stop the continuous spinning
        setupCounter(
          counterElement,
          totalBagsSaved,
          initialSpinDuration,
          stopDelay
        );

        observer.unobserve(counterElement); // Stop observing once the animation starts
      }
    });
  }, observerOptions);

  observer.observe(counterElement); // Observe the counter element

  // Check if the counter is already visible on load and start the animation
  const rect = counterElement.getBoundingClientRect();
  const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
  if (isVisible && !counterElement.animationStarted) {
    counterElement.animationStarted = true; // Prevent the animation from running multiple times

    const initialCount = parseInt(
      counterElement.getAttribute("data-initial"),
      10
    );
    const dailyIncrement = parseInt(
      counterElement.getAttribute("data-increment"),
      10
    );
    const startDate = new Date(counterElement.getAttribute("data-start-date"));
    const initialSpinDuration = parseInt(
      counterElement.getAttribute("data-spin-duration"),
      10
    );
    const stopDelay = parseInt(
      counterElement.getAttribute("data-stop-delay"),
      10
    );
    const currentDate = new Date();

    const hoursElapsed = (currentDate - startDate) / 1000 / 3600;
    const hourlyIncrement = dailyIncrement / 24;
    const totalBagsSaved =
      initialCount + Math.floor(hoursElapsed * hourlyIncrement);

    clearInterval(counterElement.spinningInterval); // Stop the continuous spinning
    setupCounter(
      counterElement,
      totalBagsSaved,
      initialSpinDuration,
      stopDelay
    );
  }
});

function setupCounter(
  counterElement,
  finalNumber,
  initialSpinDuration,
  stopDelay
) {
  const numberStr = finalNumber.toString().padStart(7, "0"); // Ensure at least 7 digits
  const digits = numberStr.split("");
  startTimer(counterElement, digits, initialSpinDuration, stopDelay); // Initial spin for 1.2s, then stop each digit every 200ms in the default scenario
}

function startTimer(counterElement, digits, initialSpinDuration, stopDelay) {
  let start = Date.now(); // remember start time
  setTimer(20, initialSpinDuration, stopDelay, counterElement, digits, start); // 20ms interval to match the final animation speed
}

function setTimer(
  delay,
  initialSpinDuration,
  stopDelay,
  counterElement,
  digits,
  start
) {
  let timer = setInterval(function () {
    let timePassed = Date.now() - start;
    const totalDuration = initialSpinDuration + stopDelay * digits.length;
    if (timePassed >= totalDuration) {
      clearInterval(timer); // finish the animation after the timeout
      draw(
        totalDuration,
        initialSpinDuration,
        stopDelay,
        counterElement,
        digits
      ); // Ensure the final value is set
      clearInterval(counterElement.spinningInterval); // Forcefully stop the continuous spinning
      return;
    }
    draw(timePassed, initialSpinDuration, stopDelay, counterElement, digits);
  }, delay);
  return timer;
}

function draw(
  timePassed,
  initialSpinDuration,
  stopDelay,
  counterElement,
  digits
) {
  const digitContainers = counterElement.childNodes;

  digitContainers.forEach((digitContainer, idx) => {
    const stopTime = initialSpinDuration + stopDelay * idx; // Calculate stop time for each digit

    if (timePassed > stopTime) {
      digitContainer.textContent = digits[idx]; // Set the correct final digit
    } else if (timePassed > initialSpinDuration) {
      digitContainer.textContent = Math.floor(Math.random() * 10); // Random spinning digits
    } else {
      digitContainer.textContent = Math.floor(Math.random() * 10);
    }
  });
}